import React from 'react';
import classNames from 'classnames';

const InformationType = (props) => {
  if (!props.Content.InformationType) return null;

  const typeClass = classNames({
    [`information-type--${props.Content.InformationType}`]: props.Content
      .InformationType,
  });

  return (
    <div className={typeClass}>
      <div className="information-type__icon"></div>
    </div>
  );
};

export default InformationType;
